<template>
  <div class="bulletin-container">
    <h1>
      Dokumentumok

      <a-icon
          v-if="loading"
          type='loading'
      />
    </h1>

    <div class="bulletin-documents-categories">
      <a-button
          type="default"
          @click="selectedCategoryIds = []; search = undefined;"
          :disabled="selectedCategoryIds.length === 0 && (search === undefined || search.length === 0)"
      >
        Összes
      </a-button>

      <div class="bulletin-documents-categories-buttons">
        <a-button
            v-for="category in categories"
            :key="category.id"
            :type="selectedCategoryIds.indexOf(category.id) !== -1 ? 'primary' : 'default'"
            @click="toggleCategory(category.id)"
        >
          {{ category.name }}
        </a-button>
      </div>
    </div>
    <div class="bulletin-documents-search">
      <a-input v-model="search" placeholder="Keresés" />
    </div>

    <div class="bulletin-documents-container">
      <BulletinFileComponent v-for="file in documents" :key="file.id" :file="file"/>
    </div>

    <div v-if="total > limit" class="pagination">
      <a-pagination v-model="current" :total="total" :page-size="limit" show-less-items />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import BulletinFileComponent from "@/components/neta/bulletin/BulletinFileComponent.vue";

export default {
  components: { BulletinFileComponent },
  computed: {
    moment() {
      return moment
    },
    offset: function () {
      return (this.current - 1) * this.limit;
    }
  },
  mounted() {
    this.fetchDocuments();
    this.fetchCategories();
  },
  data() {
    return {
      loading: false,
      documents: [],
      categories: [],
      selectedCategoryIds: [],
      search: undefined,
      current: 1,
      limit: 12,
      total: 0
    }
  },
  watch: {
    selectedCategoryIds() {
      this.fetchDocuments()
    },
    search() {
      this.fetchDocuments()
    },
    current() {
      this.fetchDocuments()
    }
  },
  methods: {
    toggleCategory(categoryId) {
      const index = this.selectedCategoryIds.indexOf(categoryId);

      if (index === -1) {
        this.selectedCategoryIds.push(categoryId);

        return;
      }

      this.selectedCategoryIds.splice(index, 1);
    },
    fetchDocuments() {
      this.loading = true;
      return new Promise((resolve) => {
        axios.get(
            '/api/v1/companies/1/documents/files', {
              params: {
                envelope: true,
                search: this.search && this.search.length > 0 ? '*' + this.search + '*' : undefined,
                filter: {
                  'status': 1,
                  'categories/id': this.selectedCategoryIds.join(','),
                },
                limit: this.limit,
                offset: this.offset,
                order: 'creationTime DESC'
              }
            }
        ).then((response) => {
          this.total = parseInt(response.data.meta.queryRecords);

          this.documents = response.data.content;

          resolve(this.documents);

          this.loading = false;
        }).catch(() => {
          this.loading = true;
          this.$message.error(
              'A hírek betöltése sikertelen!'
          );
        });
      });
    },
    fetchCategories() {
      return new Promise((resolve) => {
        axios.get(
            '/api/v1/companies/1/documents/categories', {
              params: {
                order: 'weight ASC'
              }
            }
        ).then((response) => {
          this.categories = response.data;

          resolve(this.categories);
        }).catch(() => {
          this.$message.error(
              'A kategóriák betöltése sikertelen!'
          );
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2em;
}

.bulletin-container {
  padding: 25px;
  max-width: 1024px;
  margin: auto;
}

.bulletin-documents-categories {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
}

.bulletin-documents-search {
  margin: 8px 0;
}

.bulletin-documents-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.pagination {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
</style>